import Image from "next/image";

import { TRUSTPILOT_SCORE } from "@/lib/company-stats";
import { cn } from "@/lib/utils";

/**
 * Trustpilot score shown in the nav (minimal variant and the desktop CTA row).
 *
 * Score comes from `TRUSTPILOT_SCORE` so the nav cannot drift away from the
 * rating cited in page copy — see `lib/company-stats.ts`.
 */
export function TrustpilotRating({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-x-[5px]", className)}>
      <span className="text-[18px] leading-[1.3] font-medium tracking-[-0.36px] text-[#1a1a1a]">
        Rated {TRUSTPILOT_SCORE}/5
      </span>
      <Image
        src="/icons/trustpilot-logo.svg"
        alt="Trustpilot"
        width={102}
        height={24}
        className="h-[24px] w-auto"
      />
    </div>
  );
}
